"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BarUpChart;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function BarUpChart(_ref) {
  var {
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    width: "49",
    height: "48",
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_1698_1830)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5908 4.17748L47.9058 12.2325H47.8983C48.0708 12.39 48.1383 12.6375 48.0558 12.855C47.9733 13.0725 47.7633 13.2225 47.5308 13.2225L44.6208 13.2375V37.7175C44.6208 38.025 44.3658 38.28 44.0583 38.28H32.3658C32.2158 38.28 32.0733 38.22 31.9683 38.115C31.8633 38.01 31.8033 37.8675 31.8033 37.7175V13.2975L28.9008 13.3125C28.6683 13.3125 28.4583 13.17 28.3758 12.9525C28.2933 12.735 28.3533 12.4875 28.5333 12.33L37.8483 4.17748C38.0658 3.99748 38.3808 3.99748 38.5908 4.17748ZM43.5033 12.675C43.5033 12.3675 43.7584 12.1125 44.0658 12.1125V12.105H46.0383L38.2309 5.34748L30.4158 12.1725H32.3808C32.5308 12.1725 32.6733 12.2325 32.7783 12.3375C32.8833 12.4425 32.9433 12.585 32.9433 12.735V37.1475H43.5033V12.675ZM29.7033 18.015C29.5983 17.91 29.4558 17.85 29.3058 17.85H17.6133C17.3058 17.85 17.0508 18.105 17.0508 18.4125V37.71C17.0508 37.86 17.1108 38.0025 17.2158 38.1075C17.3208 38.2125 17.4633 38.2725 17.6133 38.2725H29.3058C29.6133 38.2725 29.8683 38.0175 29.8683 37.71V18.405C29.8683 18.255 29.8083 18.1125 29.7033 18.0075V18.015ZM18.1758 37.1475V18.975H28.7358V37.155H18.1758V37.1475ZM14.4633 23.205H2.86835C2.56085 23.205 2.30585 23.46 2.30585 23.7675V27.255C2.30585 27.5625 2.56085 27.8175 2.86835 27.8175C3.17585 27.8175 3.43085 27.5625 3.43085 27.255V24.33H13.9008V37.1475H3.43085V30.675C3.43085 30.3675 3.17585 30.1125 2.86835 30.1125C2.56085 30.1125 2.30585 30.3675 2.30585 30.675V37.71C2.30585 38.0175 2.56085 38.2725 2.86835 38.2725H14.4633C14.7708 38.2725 15.0258 38.0175 15.0258 37.71V23.7675C15.0258 23.46 14.7708 23.205 14.4633 23.205Z",
    fill: "#004DB2"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.42584 32.4825C5.42584 33.8925 4.27834 35.04 2.86834 35.04C1.45834 35.04 0.303345 33.8925 0.303345 32.4825C0.303345 31.0725 1.45084 29.925 2.86084 29.925C4.27084 29.925 5.41834 31.0725 5.41834 32.4825",
    fill: "#4DC7EB"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_1698_1830"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "48",
    height: "48",
    fill: "white",
    transform: "translate(0.333344)"
  }))));
}